export default "__VITE_ASSET__Cu7u0CfL__"